// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1426":"0cdceced","2934":"b687a8a4","8992":"c6448101"}[chunkId] + ".chunk.css";
};